<template>
    <div>
        <v-toolbar
            flat
            rounded
            class="mb-5">
            <v-app-bar-nav-icon
                v-if="$vuetify.breakpoint.smAndDown"
                @click.stop="toggleLeftNavVisibility"
            />

            <v-toolbar-title class="font-weight-bold">
                <template v-if="$route.path.includes('/superadmin')">
                    <span class="font-weight-light">Super Admin Area <v-icon>mdi-chevron-right</v-icon></span>
                </template>
                {{ $route.meta.title }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
        </v-toolbar>
    </div>
</template>

<script>
import store from "../../../App/Store";

export default {
    data() {
        return {};
    },

    methods: {
        toggleLeftNavVisibility() {
            store.dispatch('toggleLeftNavVisibility', true);
        },
    }
};
</script>
